const pendingRequests = new Set<string>()

export const createBookingWithDedupe = async (
  createFn: () => Promise<any>,
  requestId: string = generateId()
): Promise<any> => {
  if (pendingRequests.has(requestId)) {
    throw new Error('Booking request already in progress')
  }

  pendingRequests.add(requestId)

  try {
    const result = await createFn()
    return result
  } finally {
    pendingRequests.delete(requestId)
  }
}

const generateId = (): string => {
  return Math.random().toString(36).substring(2) + Date.now().toString(36)
}